import { getStorage, setStorage } from '../lib/storage';
import { get, writable } from 'svelte/store';
export const createArrayStore = (options = {}) => {
    const initialValue = options.storageKey
        ? getStorage(options.storageKey, [])
        : [];
    const store = writable(initialValue);
    const getState = () => get(store);
    const updateStorage = (value) => setStorage(options.storageKey, value);
    const has = (item) => {
        const state = getState();
        return state.includes(item);
    };
    const add = (item) => {
        if (has(item))
            return;
        const state = getState();
        if (options.limit && state.length >= options.limit) {
            state.shift();
        }
        const updatedState = [...state, item];
        store.set(updatedState);
        if (options.storageKey) {
            updateStorage(updatedState);
        }
    };
    const addMany = (items) => {
        items.forEach((item) => add(item));
    };
    const remove = (item) => {
        const state = getState();
        const updatedState = state.filter((i) => i !== item);
        store.set(updatedState);
        if (options.storageKey) {
            updateStorage(updatedState);
        }
    };
    return {
        subscribe: store.subscribe,
        set: store.set,
        has,
        add,
        addMany,
        remove,
    };
};
